import { Instance } from 'mobx-state-tree';
import { CreateCustomersFromOrdersResultDtoModelBase } from './CreateCustomersFromOrdersResultDtoModel.base';

/* The TypeScript type of an instance of CreateCustomersFromOrdersResultDtoModel */
export interface CreateCustomersFromOrdersResultDtoModelType extends Instance<typeof CreateCustomersFromOrdersResultDtoModel.Type> {}

/* A graphql query fragment builders for CreateCustomersFromOrdersResultDtoModel */
export { selectFromCreateCustomersFromOrdersResultDto, createCustomersFromOrdersResultDtoModelPrimitives, CreateCustomersFromOrdersResultDtoModelSelector } from './CreateCustomersFromOrdersResultDtoModel.base';

/**
 * CreateCustomersFromOrdersResultDtoModel
 */
export const CreateCustomersFromOrdersResultDtoModel = CreateCustomersFromOrdersResultDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
